import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const InstituteCompanyCard = ({ 
  company,
  onView = () => console.log('View clicked'),
  onEdit = () => console.log('Edit clicked'),
  onDelete = () => console.log('Delete clicked')
}) => {
  const AWS = process.env.REACT_APP_AWS_HOST;
  const navigate = useNavigate();

  // Handle total jobs click - redirect to jobs page with company filter
  const handleTotalJobsClick = () => {
    // Navigate to jobs page with company name as search parameter
    navigate(`/job-page?company=${encodeURIComponent(company.name)}`);
  };

  // Handle total hired click - redirect to student application list with filters
  const handleTotalHiredClick = () => {
    // Navigate to student application list with organization ID and hired status
    navigate(`/student-application?org_id=${company.id}&status=hired`);
  };

  // Handle total applications click - redirect to student application list with company filter
  const handleTotalApplicationsClick = () => {
    // Navigate to student application list with organization ID
    navigate(`/student-application?org_id=${company.id}`);
  };

  return (
    <div className="card blueborder shadow-sm position-relative company-card">
      {/* Action Buttons - Top Right Corner */}
      <div className="position-absolute top-0 end-0 p-2">
        <Dropdown align="end">
          <Dropdown.Toggle
            as="button"
            className="btn btn-link text-muted p-0 no-caret"
          >
            <i className="bi bi-three-dots-vertical"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => onView(company)}>
              <i className="bi bi-eye me-2"></i>
              View
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => onEdit(company)}
            >
              <i className="bi bi-pencil me-2"></i>
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => onDelete(company)}
            >
              <i className="bi bi-trash me-2"></i>
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="card-body d-flex flex-column pt-4 text-center">
        {/* Company Logo - Centered at Top */}
        <div className="d-flex justify-content-center mb-2">
          <img 
            src={company.logo ? `${AWS}${company.logo}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(company.name)}&background=random`}
            onError={(e) => {
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(company.name)}&background=random`;
            }}
            alt={`${company.name} logo`}
            className="rounded-3 hover-rotate"
            style={{ 
              width: '80px', 
              height: '80px', 
              objectFit: 'contain',
              border: '2px solid #dee2e6',
              transition: 'transform 0.3s ease'
            }}
          />
        </div>

        {/* Company Name */}
        <div className="mb-2 hover-fade" style={{ minHeight:"40px"}}>
          <h5 className="mb-0 text-primary hover-text">{company.name}</h5>
          
        </div>

        {/* Location */}
        <div className="mb-1">
          <p className="text-muted mb-0">
            <small className="text-muted d-block">{company.industryName}</small>
            <i className="bi bi-geo-alt-fill me-1"></i>
            {company.city}, {company.state}
          </p>
        </div>

        {/* Contact Information */}
        <div className="mb-3 contact-info hover-fade">
          <div className="card bg-light border-0 shadow-sm mb-0">
            <div className="card-body p-3">
              <h6 className="text-primary mb-3 text-start">Contact Information</h6>
              <div className="small text-start">
                <div className="mb-2 hover-slide">
                  <i className="bi bi-person-fill me-2 text-primary"></i>
                  <span>{company.contactPerson}</span>
                </div>
                <div className="mb-2 hover-slide">
                  <i className="bi bi-telephone-fill me-2 text-primary"></i>
                  <span>{company.contactNumber}</span>
                </div>
                <div className="mb-2 hover-slide">
                  <i className="bi bi-envelope-fill me-2 text-primary"></i>
                  <span className="text-break">{company.contactEmail}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Statistics with Click Handlers */}
        <div className="row mb-2">
          <div className="col-12">
            <div 
              className="text-center p-2 bg-light rounded-1 stats-box hover-expand"
              onClick={handleTotalApplicationsClick}
              style={{ cursor: 'pointer' }}
              title="View all applications from this company"
            >
              <small className="text-muted">
                Total Applications received: <span className="text-info fw-bold">{company.totalApplications || 0}</span>
              </small>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div 
              className="text-center p-1 bg-light rounded-1 stats-box hover-expand"
              onClick={handleTotalJobsClick}
              style={{ cursor: 'pointer' }}
              title="View all jobs from this company"
            >
              <small className="text-muted">
                Total Jobs: <span className="text-primary fw-bold">{company.totalPosts}</span>
              </small>
            </div>
          </div>
          <div className="col-6">
            <div 
              className="text-center p-1 bg-light rounded-1 stats-box hover-expand"
              onClick={handleTotalHiredClick}
              style={{ cursor: 'pointer' }}
              title="View hired candidates from this company"
            >
              <small className="text-muted">
                Total Hired: <span className="text-success fw-bold">{company.totalHired}</span>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstituteCompanyCard;